import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  typography: {
    fontFamily: ['Pretendard', '-apple-system', 'BlinkMacSystemFont', 'system-ui', 'Roboto', 'sans-serif'].join(','),
    fontSize: 14,
    htmlFontSize: 16,
    h1: {
      fontSize: '1.75rem', //28px
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: '1.5rem', //24px
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: '1.25rem', //20px
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h4: {
      fontSize: '1.125rem', //18px
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h5: {
      fontSize: '1rem', //16px
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h6: {
      fontSize: '0.875rem', //14px
      fontWeight: 600,
      lineHeight: 1.4,
    },
    body1: {
      fontSize: '0.875rem', //14px
      lineHeight: 1.5,
    },
    body2: {
      fontSize: '0.8125rem', //13px
      lineHeight: 1.5,
    },
    subtitle1: {
      fontSize: '0.875rem', //14px
      fontWeight: 500,
      lineHeight: 1.4,
    },
    subtitle2: {
      fontSize: '0.8125rem', //13px
      fontWeight: 500,
      lineHeight: 1.4,
    },
    button: {
      fontSize: '0.875rem', //14px
      fontWeight: 500,
      textTransform: 'none',
    },
    caption: {
      fontSize: '0.75rem', //12px
      lineHeight: 1.4,
    },
  },
  palette: {
    gray: {
      main: '#4f4f4f',
      disabled: '#767676',
      border: '#d9d9d9',
      background: '#f5f5f5',
      lightGray: '#929292',
    },
    blue: {
      main: '#1976d2',
    },
  },
  components: {},
});

export const adminTheme = createTheme({
  palette: {
    mode: 'light',
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 600,
      lg: 1200,
      xl: 1536,
    },
  },
});

export default theme;
